import { predefinedDomains } from "./predefinedDomains";

const LOGO_DEV_PUBLIC_KEY = "pk_YZ3AISgETzOMOjTbbIHN8g";

export const getLogo = (emailOrWebsite: string | undefined) => {
  if (!emailOrWebsite || predefinedDomains.includes(emailOrWebsite)) {
    return undefined;
  }
  return `https://img.logo.dev/${emailOrWebsite}?token=${LOGO_DEV_PUBLIC_KEY}`;
};
